import { IPrescriptionsMedication } from 'API';

export const isPrescriptionMedication = (
  object: any
): object is IPrescriptionsMedication => {
  return 'supplyind' in object;
};
